module.exports = __webpack_public_path__ + "img/3dzz.856de741.png";